import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { bestSellingItemsReportRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const bestSellingItemsReportRouteMetadata: IRouteMetadataObj<
  typeof bestSellingItemsReportRoutesObj
> = {
  list: {
    title: "reportManagement.index.title",
    description: "empty",
    lazy: () =>
      import("@pages/reportManagement/bestSellingItemsReport/table/page"),
    mode: "index",
    type: "main",
    icon: "FileChartLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "reportManagement.bestSellingItems.view.title",
    description: "empty",
    lazy: () => import("@pages/warehouseManagement/addNewItem/editItem/page"),
    mode: "view",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
};

export const bestSellingItemsReportRoutes = createRoute<
  typeof bestSellingItemsReportRoutesObj
>(bestSellingItemsReportRoutesObj, bestSellingItemsReportRouteMetadata);
